import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalFunctionsService } from '../../common/functions/global-functions.service';
import { SettingsService } from 'src/app/core/settings/settings.service';
import { ReportsService } from "../reports.service";
import { CalendarService } from '../../configuration/calendar/calendar.service';
import { AdjustService } from '../../inventory/adjust/adjust.service';
import { Unit } from '../../common/models/Unit.Model';
import { Region } from '../../common/models/Region.Model';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-rep-ongoing',
  templateUrl: './rep-ongoing.component.html',
  styleUrls: ['./rep-ongoing.component.scss']
})
export class RepOngoingComponent implements OnInit {
  
  // Control UI
  downloading: boolean = false;
  
  // Listas
  regionList: Region[] = [];
  nodeList: Unit[] = [];
  
  // Modelos de selección
  unit: any;                // ID de Región
  type: number = 0;         // ID de Clasificación (0: Planta, 1: CEVE)
  selectedOriginUnit: any;  // ID del Nodo seleccionado
  typeLevel: string = 'FAB';

  constructor(
    private reportsService: ReportsService,
    private calendarService: CalendarService,
    private router: Router,
    private settingsService: SettingsService,
    private globalFunctionService: GlobalFunctionsService,
    private adjustService: AdjustService
  ) { }

  async ngOnInit() {
    this.globalFunctionService.canOperate();
    this.globalFunctionService.hasFSBRPending();

    // Validar Inventario
    this.calendarService.CalendarInventoryInProgress().subscribe(calendar => {
      if (calendar && calendar.length === 1) {
        this.globalFunctionService.messageToast(`No es posible realizar esta operación, se encuentra en toma de inventario físico.`, 'warning');
        this.router.navigate([`/home`]);
      }
    });

    // Validar Compulsa
    const resp = await this.adjustService.validateAdjustActive(this.settingsService.getUser().UnitId).toPromise();
    if (resp && resp.AdjustCode !== '') {
      this.globalFunctionService.messageToast(`No es posible realizar esta operación, se encuentra en compulsa.`, 'warning');
      this.router.navigate([`/home`]);
    }

    this.getRegions();
  }

  getRegions() {
    this.reportsService.getRegionUnit().subscribe(data => {
      this.regionList = data;
      if (this.regionList.length > 0) {
        this.unit = this.regionList[0].UnitId;
        this.getNodes(this.typeLevel);
      }
    });
  }

  // Se ejecuta al cambiar Región
  applyFilters(unitId: any) {
    this.unit = unitId;
    this.selectedOriginUnit = undefined;
    this.getNodes(this.typeLevel);
  }

  // Se ejecuta al cambiar Clasificación
  cmbUnitChange(typeId: any) {
    this.type = typeId;
    this.typeLevel = (typeId == 0) ? 'FAB' : 'CEVE';
    this.selectedOriginUnit = undefined;
    this.getNodes(this.typeLevel);
  }

  getNodes(level: string) {
    if (!this.unit) return;

    this.nodeList = [];
    this.reportsService.getNodeByRegionLevel(this.unit, level).toPromise()
      .then((resp: Unit[]) => {
        this.nodeList = resp;
      })
      .catch(() => {
        this.globalFunctionService.messageToast(`No se encontraron nodos.`, 'warning');
      });
  }

  onOriginUnitChange(unitId: any) {
    this.selectedOriginUnit = unitId;
  }

  async download() {
    // Definir unidad a descargar según lógica original si no hay nodo seleccionado
    let unitToDownload = this.selectedOriginUnit;
    
    if (unitToDownload === undefined) {
      unitToDownload = (this.typeLevel === 'FAB') ? 2 : 1;
    }

    await this.globalFunctionService.messageBimbo('Por favor espere...', 'loading', 'Generando reporte de tránsito');
    this.downloading = true;

    this.reportsService.getOngoingReportExcel(unitToDownload, this.unit).subscribe({
      next: (resp: any) => {
        Swal.close();
        if (!resp || resp.size === 0) {
          this.globalFunctionService.messageToast(`No se ha encontrado información.`, 'warning');
          this.downloading = false;
          return;
        }

        const blob = new Blob([resp], { type: resp.type });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');

        // Nombre dinámico del archivo
        const regionName = this.regionList.find(r => r.UnitId == this.unit)?.RegionName || 'General';
        anchor.download = `Reporte_Transito_${regionName}.xlsx`;
        
        anchor.href = url;
        anchor.click();
        window.URL.revokeObjectURL(url);

        this.downloading = false;
      },
      error: (err) => {
        Swal.close();
        console.log(err);
        this.globalFunctionService.messageToast(`Error en la descarga.`, 'error');
        this.downloading = false;
      }
    });
  }
}